export default __webpack_public_path__ + "static/react-web-9bf8eba10e0aad10a3943a6a0bf20a29.jpg";